import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { OrdersListControllerModule } from './controllers/OrdersListController';

export const OrdersListView = angular
  .module('acme.view.application.orders.list', [
    uiRouter,
    'ui.bootstrap',
    OrdersListControllerModule,
    'acme.common.directive.dataGrid',
    'acme.common.service.userPreferences',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.orders.list',
      url: '/list?page&type&date&search',
      reloadOnSearch: true,
      views: {
        'subview-main': {
          controller: 'OrdersListController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/list/list.tpl.html',
        },
      },
      data: {
        pageTitle: 'Orders list',
        permissions: ['ORDER_VIEW'],
        enablePreferences: true,
      },
    });
  }).name;
